// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12pjT","list":"styles_list__fWdYI"};